<fcom-modal
  [title]="'CORPORATE.corporatePortal.tripsView.rebookTrip' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [fitToContent]="true"
  [(open)]="modalOpen"
  (confirm)="rebookTrip()"
  (close)="modalOpen = false"
>
  <ng-container [ngTemplateOutlet]="modalContent"></ng-container>

  <div buttons>
    <fcom-button
      class="mr-xsmall-r"
      [text]="'actions.cancel' | finLocalization"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      (clickBtn)="modalOpen = false"
    ></fcom-button>
    <fcom-button
      [disabled]="(valid$ | async) === false"
      [aria]="{ loadingLabel: 'actions.loading' | finLocalization }"
      [loading]="loading"
      [text]="'CORPORATE.corporatePortal.tripsView.rebookTripBtn' | finLocalization"
      (clickBtn)="rebookTrip()"
    ></fcom-button>
  </div>
</fcom-modal>

<ng-template #modalContent>
  <div class="pr-large-x pr-medium-y" *ngIf="trip">
    <h5 class="font-heading-5">
      {{ trip.departure.locationTitle }}
      <ng-container [ngSwitch]="trip.tripType">
        <fcom-icon
          *ngSwitchCase="TripType.ONEWAY"
          class="icon-small ms-xxsmall-x"
          [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL"
        ></fcom-icon>
        <fcom-icon
          *ngSwitchCase="TripType.RETURN"
          class="icon-small ms-xxsmall-x"
          [name]="SvgLibraryIcon.RETURN_TRIP"
        ></fcom-icon>
        <fcom-icon
          *ngSwitchCase="TripType.MULTICITY"
          class="icon-small ms-xxsmall-x"
          [name]="SvgLibraryIcon.MULTISTOP"
        ></fcom-icon>
      </ng-container>
      {{ trip.arrival.locationTitle }}
      <ng-container *ngIf="trip.tripType === TripType.MULTICITY">
        (+{{ trip.bounds.length - 1 }} {{ 'CORPORATE.corporatePortal.tripsView.flights' | finLocalization }})
      </ng-container>
    </h5>
    <fcom-tag [ngSwitch]="trip.tripType">
      <ng-container *ngSwitchCase="TripType.ONEWAY">
        {{ 'CORPORATE.corporatePortal.tripType.oneway' | finLocalization }}
      </ng-container>
      <ng-container *ngSwitchCase="TripType.RETURN">
        {{ 'CORPORATE.corporatePortal.tripType.return' | finLocalization }}
      </ng-container>
      <ng-container *ngSwitchCase="TripType.MULTICITY">
        {{ 'CORPORATE.corporatePortal.tripType.multicity' | finLocalization }}
      </ng-container>
    </fcom-tag>
    <div class="flex font-body-1 ms-large-y">
      <div class="fill--50">
        <div class="bold-type">
          {{ 'CORPORATE.corporatePortal.tripsView.passengers' | finLocalization }} ({{ trip.passengers.length }}):
        </div>
        <div class="comma-separated">
          @for (pax of trip.passengers; track pax) {
            <span>{{ pax.firstName | titlecase }} {{ pax.lastName | titlecase }}</span>
          }
        </div>
      </div>
      <div class="fill--50">
        <div class="bold-type">{{ 'travelClasses' | finLocalization }}</div>
        <div>{{ 'travelClass.' + trip.bookingClass.toLowerCase() | finLocalization }}</div>
      </div>
    </div>

    <ng-container [ngSwitch]="trip.tripType">
      <div *ngSwitchCase="TripType.ONEWAY">
        <fin-travel-dates-selector
          [showSeparator]="false"
          [showAddReturn]="false"
          [showPerAdultPrice]="false"
          [showFlexibleDatesSelection]="false"
          [isOneway$]="true | finToObservable"
          [travelDates$]="travelDates$[0]"
          [tripType$]="PriceCalendarTripType.ONEWAY | finToObservable"
          [locations$]="
            {
              origin: trip.departure,
              destination: trip.arrival,
            } | finToObservable
          "
          [priceCalendarType]="PriceCalendarType.ONLY_DATES"
          (setTravelDates)="setTravelDates($event)"
          data-testid="rebook-trip-dates-selector-oneway"
        ></fin-travel-dates-selector>
      </div>
      <div *ngSwitchCase="TripType.RETURN">
        <fin-travel-dates-selector
          [showSeparator]="true"
          [showAddReturn]="false"
          [showPerAdultPrice]="false"
          [showFlexibleDatesSelection]="false"
          [travelDates$]="travelDates$[0]"
          [tripType$]="PriceCalendarTripType.RETURN | finToObservable"
          [locations$]="
            {
              origin: trip.departure,
              destination: trip.arrival,
            } | finToObservable
          "
          [priceCalendarType]="PriceCalendarType.ONLY_DATES"
          (setTravelDates)="setTravelDates($event)"
          data-testid="rebook-trip-dates-selector-return"
        ></fin-travel-dates-selector>
      </div>
      <div *ngSwitchCase="TripType.MULTICITY">
        @for (bound of trip.bounds; track bound; let i = $index) {
          <div class="ms-large-b">
            <div class="font-body-1 bold-type ps-xxsmall-b">
              {{ i + 1 }}. {{ bound.departure.locationTitle }}
              <fcom-icon class="icon-small ms-xxsmall-x" [name]="SvgLibraryIcon.AIRCRAFT_HORIZONTAL"></fcom-icon>
              {{ bound.arrival.locationTitle }}
            </div>
            <fin-travel-dates-selector
              [showSeparator]="false"
              [showAddReturn]="false"
              [showPerAdultPrice]="false"
              [showFlexibleDatesSelection]="false"
              [isOneway$]="true | finToObservable"
              [travelDates$]="travelDates$[i]"
              [tripType$]="PriceCalendarTripType.MULTICITY | finToObservable"
              [priceCalendarType]="PriceCalendarType.ONLY_DATES"
              [previousFlightDepartureDate$]="
                i > 0 ? ((travelDates$[i - 1] | async).departureDate | finToObservable) : EMPTY
              "
              [locations$]="
                {
                  origin: bound.departure,
                  destination: bound.arrival,
                } | finToObservable
              "
              (setTravelDates)="setTravelDates($event, i)"
              data-testid="rebook-trip-dates-selector-multicity"
            ></fin-travel-dates-selector>
          </div>
        }
      </div>
    </ng-container>
  </div>
</ng-template>
